var AppointmentSummaryCtrl = function ($rootScope, $scope, $element, $interval, $anchorScroll, previousState,
    customerModelService, $log, SettingsConstants, $state, apiService, $q,
    dealerModelService, VALIDATION, loaderService, maintenanceModelService,
    errorScreenService, ERR, errorRouterService, ssWidgetService,
    $timeout, sdAnalyticsService, vehicleService, apiConstants, $filter) {
    // get required information
    var customer = customerModelService.getCustomer();
    //TODO should be discussed with the DC
    $scope.phonePattern = VALIDATION.PHONE_NUMBER;
    $scope.emailPattern = VALIDATION.EMAIL_PATTERN;
    $scope.firsNameMaxLen = VALIDATION.FIRST_NAME_MAX_LENGTH;
    $scope.lastNameMaxLen = VALIDATION.LAST_NAME_MAX_LENGTH;
    $scope.emailMaxLen = VALIDATION.EMAIL_MAX_LENGTH;
    //TODO use customerEmailRequired value after API implementation.
    $scope.emailRequred = window.appSettings.customerEmailRequired = true;
    $scope.opCodesBlockingEnabled = window.appSettings.opCodesBlockingEnabled;
    $scope.displayTotalPrice = window.appSettings.displayTotalPrice;
    $scope.isExpressDepartment = false;
    //this wrapper need for getting form model from ng-if scope
    $scope.forms = {
        newCustomerForm: {}
    };
    //check if current customer is new or existing
    $scope.newCustomer = customerModelService.isNewCustomer(customer);
    //get current appointment data
    $scope.currentAppointment = customerModelService.getCurrentAppointment();
    //default error screen options
    var defaultErrorScreenOptions = {
        template: 'template/errorscreens/booking-error',
        errorType: ERR.BOOK_ERROR,
        dealerPhone: window.appSettings.dealerInfo.phone,
        dealerEmail: window.appSettings.dealerInfo.email
    };
    //flag defines error while booking process
    $scope.bookError = false;
    //on this state we have two possible situations -
    //
    //first one - we are working with a new customer. In this case we should create
    //empty customer object.
    //
    //second one - we are working with existing customer. In this case we should use
    //data from customer model.
    if (!customer) {
        $scope.customer = {
            vehicle: '',
            firstName: '',
            lastName: '',
            email: '',
            phone: ''
        };
        customerModelService.setCustomer($scope.customer);
    } else {
        $scope.customer = {
            id: customer.id,
            vehicle: customerModelService.getCurrentVehicle(),
            firstName: customer.firstName,
            lastName: customer.lastName,
            email: customer.email || customer.getDefaultEmail(),
            phone: customer.phone || customer.getDefaultPhone(),
            existingCustomer: customer.existingCustomer,
            foundType: customer.foundType
        };
        customerModelService.setCustomer($scope.customer);
    }

    //set current vehicle
    $scope.vehicle = customerModelService.getCurrentVehicle();
    //set odometer value kind (km/mi)
    $scope.odometerValueKind = $scope.vehicle.getManufacturer().kilometersOrMiles;
    //set service adviser
    $scope.serviceAdviser = customerModelService.getCurrentAdviser();

    //set transportation option
    $scope.transportationOption = customerModelService.getCurrentTransportationOption();

    $scope.concernsDescription = customerModelService.getConcernsDescription();
    //check ability for resolving vehicle updates.
    $scope.isRecallsEnabled = window.appSettings.enableRecalls && _.isFunction($scope.vehicle.resolveRecalls);

    // Check showVehicleAlerts setting
    $scope.showVehicleAlerts = window.appSettings.ossShowVehicleAlerts;

    // get all services that customer has schosen due to appointment
    // wizard
    $scope.services = customerModelService.getSelectedMaintenanceServices();
    $scope.recalls = customerModelService.getMergedRecalls();
    $scope.confirmationCode = customerModelService.getConfirmationCode();
    $scope.serviceContractEndDate = moment.parseZone(customerModelService.getServiceContract().EndDate, moment.ISO_8601).format('YYYY-MM-DD');
    var frsListener = $scope.$on('bookAppoimentServicesCtrl:reloadFRS', function () {
        $scope.services = customerModelService.getSelectedMaintenanceServices();
        if ($scope.services) {            
            var oilPrice = $scope.services.factoryRequired.filter(x => x.mvpServiceContractOilChange == apiConstants.SERVICECONTRACTS.OilFilterChange);
            var tireRotationPrice = $scope.services.factoryRequired.filter(x => x.mvpServiceContractTireRotation == apiConstants.SERVICECONTRACTS.TireRotaion);
            //analyticsMsrp is the permanent price.
            if (tireRotationPrice && tireRotationPrice.length) {
                $scope.tireRotationPrice = tireRotationPrice[0].analyticsMsrp;
            }
            if (oilPrice && oilPrice.length) {
               $scope.oilPrice = oilPrice[0].analyticsMsrp;
            }

            $scope.services.factoryRequired.forEach(el => {
                //Checking tire rotation and oil filter services which covered under service contract with valid apointment date
                if (((el.mvpServiceContractOilChange == apiConstants.SERVICECONTRACTS.OilFilterChange && $scope.serviceContractsValid().IsContractOilValid) || (el.mvpServiceContractTireRotation == apiConstants.SERVICECONTRACTS.TireRotaion && $scope.serviceContractsValid().IsContractTireRotaionValid)) && (Date.parse($scope.serviceContractEndDate) >= Date.parse($scope.scheduledUnFormatedDateTime))) {
                    el.price = 0
                }
                //Checking serviceContractEndDate and tire rotation and oil filter services which covered under service contract with valid apointment date
                else if (Date.parse($scope.serviceContractEndDate) < Date.parse($scope.scheduledUnFormatedDateTime)) {
                    if (el.mvpServiceContractTireRotation == apiConstants.SERVICECONTRACTS.TireRotaion && $scope.serviceContractsValid().IsContractTireRotaionValid) {
                        el.price = $scope.tireRotationPrice;                              
                    }
                    else if (el.mvpServiceContractOilChange == apiConstants.SERVICECONTRACTS.OilFilterChange && $scope.serviceContractsValid().IsContractOilValid) {
                        el.price = $scope.oilPrice;
                    }                        
                }
                
            });
        }
    });

    var httpErrorsListeners = [];

    httpErrorsListeners.push(errorRouterService.subscribe(function () {
        //do nothing if http error happens due to matching customer
        //procedure
        return $q.when(true);
    }, { resourceName: 'CustomerMatch', status: '*' }));

    httpErrorsListeners.push(errorRouterService.subscribe(function (err) {
        //invokeGetItemError();
        $log.error('createAppointment error', err);
        return $q.when(true);
    }, { resourceName: 'createAppointment', status: '*' }));

    $scope.toggleUpdatesPopup = function () {
        $scope.showUpdatesPopup = !$scope.showUpdatesPopup;
    };

    $scope.checkRecallsAlertsUpdates = function () {
        if ($scope.isRecallsEnabled) {
            $scope.recallsPending = true;

            customerModelService.resolveRecallsUpdates().then(function (data) {
                $scope.recalls = customerModelService.getMergedRecalls();

                if (_.size(data)) {
                    $scope.showUpdatesMsg = true;
                }
            })
                .catch(function (err) {
                    $scope.recalls = null;
                })
                .finally(function () {
                    $scope.recallsPending = false;
                });
        }

        // 37594: TMNA SmartPath - OS - Display Vehicle Alerts on Appointment Summary Page (SP7)
        if ($scope.showVehicleAlerts) {
            getVehicleAlerts();
        }
    };

    $scope.selectSurvey = function (survey) {
        if ($scope.isBookedApp()) return false;
        $state.go('summary.survey', {
            serviceId: survey.serviceId,
            templateId: survey.templateId,
            name: survey.templateName,
        });
    };

    $scope.removeSurvey = function (ev, customerConcern) {
        ev.preventDefault();
        ev.stopPropagation();
        ssWidgetService.removeSurveyInstance(customerConcern.survey.link)
            .then(function (r) {
                $timeout(function () {
                    delete customerConcern.survey;
                });
            })
            .catch(function (e) {
                console.error('Something went wrong. Could not delete survey data %o', e);
            });
    };

    function init() {
        //formatTime
        var currentScheduledTime = customerModelService.getCurrentScheduledTime();
        if (currentScheduledTime) {
            $scope.scheduledDate = moment.parseZone(currentScheduledTime.time, moment.ISO_8601).format('LL');
            $scope.scheduledTime = moment.parseZone(currentScheduledTime.time, moment.ISO_8601).format('LT');
            $scope.scheduledDateTime = moment.parseZone(currentScheduledTime.time, moment.ISO_8601).format('LLLL');
            $scope.scheduledUnFormatedDateTime = moment.parseZone(currentScheduledTime.time, moment.ISO_8601).format('YYYY-MM-DD');
        }

        if ($scope.isRecallsEnabled) {
            var recalls = customerModelService.getRecallsUpdates();
            if (!recalls) {
                $scope.checkRecallsAlertsUpdates();
            } else {
                $scope.recalls = customerModelService.getMergedRecalls();
                $scope.showUpdatesMsg = _.size(recalls) && previousState.name === 'checkhealth';
            }
        }

        getSummaryPrice();

        // 37594: TMNA SmartPath - OS - Display Vehicle Alerts on Appointment Summary Page (SP7)
        if ($scope.showVehicleAlerts) {
            getVehicleAlerts();
        }

        dealerModelService.resolveDepartment(_.flatMap(customerModelService.getSelectedMaintenanceServices()))
            .then(function (department) {
                customerModelService.setCurrentDepartment(department);
                $scope.isExpressDepartment = department.express;
            });
            
        if (window.appSettings.enableProtectionPlans) {
            checkProtectionPlanUpdates();
        }
    }

    init();

    //get summary price for appointment
    function getSummaryPrice() {
        if (!$scope.displayTotalPrice) return;

        $scope.loadingSummary = true;

        var vehicle = customerModelService.getCurrentVehicle();
        var vehicleHref = _.get(_.find(_.get(vehicle, 'links'),
            function (link) {
                return link.rel == 'self' || link.rel == 'http://api.dealer-fx.com/docs/rels/vehicle';
            }), 'href');


        var maintenanceIntervals = maintenanceModelService.getMaintenanceIntervals();
        var selectedMaintenancePeriod = maintenanceModelService.getSelectedMaintenanceInterval(maintenanceIntervals);

        apiService.getCatalog()
            .then(function (catalog) {
                // var services = _.flatMap($scope.services).filter(function (el) { return !!el.opCode })
                var services = _.flatMap($scope.services); // #36431 We decided to remove the filtering of services without opCode,
                // as the filtering was only needed to remove surveys.
                if (services) {
                    services.forEach(el => {
                        //Checking tire rotation and oil filter services which covered under service contract with valid apointment date
                        if (((el.mvpServiceContractOilChange == apiConstants.SERVICECONTRACTS.OilFilterChange && $scope.serviceContractsValid().IsContractOilValid) || (el.mvpServiceContractTireRotation == apiConstants.SERVICECONTRACTS.TireRotaion && $scope.serviceContractsValid().IsContractTireRotaionValid)) && (Date.parse($scope.serviceContractEndDate) >= Date.parse($scope.scheduledUnFormatedDateTime))) {
                            services = services.filter(x => x.id != el.id)
                        }
                    });
                }
                return catalog.getAppointmentSummary({
                    services: services,
                    vehicle: { links: [{ rel: 'http://api.dealer-fx.com/docs/rels/vehicle', href: vehicleHref }] },
                    mileage: 0
                });
            })
            .then(function (data) {
                $scope.summary = data;
                $rootScope.total = $scope.summary.total;
            })
            .catch(function (err) {
                $log.error('Something went wrong due to calculating price for appointment');
            })
            .finally(function () {
                $scope.loadingSummary = false;
            });
    }

    // To get Vehicle Alerts to show on UI
    function getVehicleAlerts() {
        $scope.vehicleAlertsAvailable = false;
        $scope.alerts = [];
        $scope.vehicleAlerts = [];
        $scope.vehicleAlertsPending = false;

        if ($scope.showVehicleAlerts) {
            $scope.vehicleAlertsPending = true;
            var services = $scope.services;

            if (customerModelService.areVehicleAlertsLoaded()) {
                // Reuse alerts if they have been loaded before
                $scope.alerts = customerModelService.getMergedAlerts();
                $scope.vehicleAlerts = services.vehicleAlerts;
                $scope.vehicleAlertsPending = false;
            }
            else {
                customerModelService.resolveAlertsUpdates()
                    .then(function (alerts) {
                        $scope.alerts = customerModelService.getMergedAlerts();
                        $scope.vehicleAlerts = services.vehicleAlerts;

                        if (vehicleAlerts.length > 0) {
                            $scope.vehicleAlertsAvailable = true;
                        }
                    })
                    .catch(function (error) {
                        $log.error('Failed to get vehicle alerts', error);
                        $scope.alerts = [];
                        $scope.vehicleAlerts = [];
                    })
                    .finally(function () {
                        $scope.vehicleAlertsPending = false;
                    });
            }

            if ($scope.vehicleAlerts.length > 0) {
                $scope.vehicleAlertsAvailable = true;
            }
        }
    }

    $scope.foundUserConfirm = function () {

        var vehicle = customerModelService.getCurrentVehicle();

        if (vehicle.links) {
            vehicle.links = vehicle.links.map(function (el) {
                if (el.rel === 'http://api.dealer-fx.com/docs/rels/vehicle') {
                    el.href = $scope.foundVehicleLink.href;
                }
                return el;
            });
        } else {
            vehicle.links = [$scope.foundVehicleLink];
        }

        $scope.newCustomer = customerModelService.isNewCustomer($scope.foundUser);
        customer = $scope.foundUser;
        customerModelService.setCustomer($scope.foundUser, true);

        $scope.customer = {
            id: $scope.foundUser.id,
            vehicle: customerModelService.getCurrentVehicle(),
            firstName: $scope.foundUser.firstName,
            lastName: $scope.foundUser.lastName,
            email: $scope.foundUser.getDefaultEmail(),
            phone: $scope.foundUser.getDefaultPhone()
        };

        $scope.foundUser = null;
        if (!vehicle.vin && vehicle.getVehicle && !$scope.newCustomer) {
            vehicle.getVehicle().then(function (v) {
                const currentOdometerValue = _.get(customerModelService.getCurrentVehicle(), 'odometer', null)
                const userVehicle = vehicleService.extend(v);
                userVehicle.odometer = currentOdometerValue;
                customerModelService.setCurrentVehicle(userVehicle);
                createAppointment();
            }.bind(this))
        } else {
            createAppointment();
        }
    };
    $scope.foundUserReject = function () {
        $scope.foundUser = null;
        createAppointment();
    };

    // getSelectedItemsAmount
    //
    // @return {object} selected items amount
    //  amount - total items amount
    //  price - total items price
    //
    // @description
    // Method returns object that contains information about all selected services
    // amount and their total price
    $scope.getSelectedItemsAmount = function () {
        return customerModelService.getSelectedServicesAmount();
    };

    // go to previous state
    $scope.goBack = function () {
        $state.go(previousState.name, previousState.params);
    };

    // go to book appointment
    $scope.bookAppointment = function () {

        $scope.disableBookAppointmentButton = true;

        if (!customerModelService.getSelectedServicesAmount().amount
            && !window.appSettings.allowAppointmentWithoutServicesSelected) {
            $state.go('bookappointment.noservices');
            return;
        }

        if ($scope.newCustomer) {
            if ($scope.forms.newCustomerForm.$valid) {
                //code for saving customer data
                _.unset($scope.customer, 'id');
                var vehicle = customerModelService.getCurrentVehicle();

                var vehicleHref = _.get(_.find(_.get(vehicle, 'links'),
                    function (link) {
                        return link.rel == 'self' || link.rel == 'http://api.dealer-fx.com/docs/rels/vehicle';
                    }), 'href');

                var vehicleInfo = {
                    ManufacturerId: _.get(vehicle, '_manufacturer.id'),
                    Year: _.get(vehicle, '_year.id'),
                    ModelId : _.get(vehicle, '_model.id'),
                    TransmissionId : _.get(vehicle, '_transmission.id'),
                    CylinderId : _.get(vehicle, '_engine.id'),
                    DriveId : _.get(vehicle,'_driveTrain.id'),
                }

                apiService.getCatalog()
                    .then(function (catalog) {
                        return catalog.CustomerMatch({
                            customer: _.omit($scope.customer, 'vehicle'),
                            vehicle: { links: [{ rel: 'http://api.dealer-fx.com/docs/rels/vehicle', href: vehicleHref }] },
                        });
                    }.bind(this))
                    .then(function (result) {
                        var customer = result.customer;
                        $scope.foundUser = customer;
                        $scope.foundUserPhone = result.defaultPhone;
                        $scope.foundUserEmail = result.defaultEmail;
                        $scope.foundVehicleLink = result.links.filter(function (el) {
                            return el.rel === "http://api.dealer-fx.com/docs/rels/vehicle";
                        })[0];
                    }.bind(this))
                    .catch(function () {
                        createAppointment();
                    });
            }
            else {
                setDirtyFormFields($scope.forms.newCustomerForm);
                $scope.disableBookAppointmentButton = false;
            }
        }
        else {
            createAppointment();
        }
    };

    function setDirtyFormFields(form) {
        _.forEach(form.$error, function (type) {
            _.forEach(type, function (field) {
                field.$setDirty();
            });
        });
        $scope.$broadcast('setFocusOnError');
        $anchorScroll('newcustomerform');
    }

    function sendStatistics(appointment) {
        try {

            function checkServiceComment(service, type) {
            }

            var repair = customerModelService.getCustomerConcernsServices();
            repair.map(function (item) {
                checkServiceComment(item, 'repair')
            });

            var frs = customerModelService.getFactoryRequiredServices();
            frs.map(function (item) {
                checkServiceComment(item, 'frs')
            });
            var frsPreselected = frs.filter(function (service) {
                return service.preselected;
            }).length;
            var frsSelected = frs.filter(function (service) {
                return service.selected;
            }).length;
            var frsPreselectedRemoved = frs.filter(function (service) {
                return service.preselected && !service.selected;
            }).length;

            var drs = customerModelService.getDealerRecommendedServices();
            drs.map(function (item) {
                checkServiceComment(item, 'drs')
            });
            var drsPreselected = drs.filter(function (service) {
                return service.preselected;
            }).length;
            var drsSelected = drs.filter(function (service) {
                return service.selected;
            }).length;
            var drsPreselectedRemoved = drs.filter(function (service) {
                return service.preselected && !service.selected;
            }).length;
            var oldAppointment = customerModelService.getCurrentAppointment();
            if (oldAppointment) {

                function getDiffCount(items, oldItems) {
                    var added = 0;
                    var selected = 0;
                    items.map(function (item) {
                        if (!item.selected) return;
                        selected++;
                        var exist = oldItems.filter(function (old) {
                            return item.id === old.id;
                        }).length > 0;
                        if (!exist) added++;
                    });
                    var removed = oldItems.length - (selected - added);
                    return added + removed;
                }

            }

        } finally {
            //return $q.when();
        }

    }

    var isGarbage = function (o) {
        return o === null || o === undefined ||
            (_.isString(o) && o.length == 0) ||
            ((_.isObject(o) || _.isArray(o)) && _.size(o) == 0)
    };

    function createAppointment() {
        var services = customerModelService.getSelectedMaintenanceServices();
        var serviceAdvisor = customerModelService.getCurrentAdviser();
        var vehicle = customerModelService.getCurrentVehicle();
        var vehicleHref = _.get(_.find(_.get(vehicle, 'links'),
            function (link) {
                return link.rel == 'self' || link.rel == 'http://api.dealer-fx.com/docs/rels/vehicle';
            }), 'href');

        var mapServiceFunction = function (o) {
            return _.omitBy({ id: o.id, comment: o.comment }, isGarbage);
        };

        var repairsAndAlertsAndProtectionPlans = _.map(services.customerConcerns.concat(services.vehicleAlerts).concat(services.protectionPlans), mapServiceFunction);

        var appointment = _.omitBy({
            vehicle: { links: [{ rel: 'http://api.dealer-fx.com/docs/rels/vehicle', href: vehicleHref }] },
            services: _.omitBy({
                repair: repairsAndAlertsAndProtectionPlans,
                frs: _.map(services.factoryRequired, mapServiceFunction),
                drs: _.map(services.dealerRecommended, mapServiceFunction),
                recalls: _.map(services.recallsUpdates, mapServiceFunction)
            }, isGarbage),
            customer: ($scope.newCustomer || !$scope.customer.id) ? _.omitBy(_.omit($scope.customer, 'vehicle'), isGarbage) : { id: _.get(customer, 'id') },
            customerConcernsInfo: customerModelService.getConcernsDescription(),
            advisor: _.omitBy({ id: _.get(serviceAdvisor, 'id', null) }, isGarbage),
            transportationOption: _.omitBy({
                'code': customerModelService.getCurrentTransportationOption().code,
                'deliveryInfo': {
                    'pickupAddress': customerModelService.getTransportationPickupAddress(),
                    'deliveryAddress': customerModelService.getTransportationDeliveryAddress()
                }
            }, isGarbage),
            //scheduledTime: moment.parseZone(_.get(customerModelService.getCurrentScheduledTime(), 'time')).format("YYYY-MM-DDTHH:mm:ss"),
            scheduledTime: _.get(customerModelService.getCurrentScheduledTime(), 'time'),
            mileage: {
                value: _.get(customerModelService.getCurrentVehicle(), 'odometer', null),
                unitsKind: 'mileage'
            }
        }, isGarbage);

        //screen with count down
        showTimeout('confirm');

        return dealerModelService.resolveDepartment(_.flatMap(customerModelService.getSelectedMaintenanceServices()))
            .then(function (department) {
                customerModelService.setCurrentDepartment(department);
                // in case if we edit existing appointment
                const currentAppointment = customerModelService.getCurrentAppointment();
                if (currentAppointment) {
                    const appointmentLink = _.find(_.get(currentAppointment, 'links'),
                        function (link) {
                            return link.rel === 'self' || link.rel === 'http://api.dealer-fx.com/docs/rels/appointment';
                        });
                    appointment.links = [appointmentLink].concat(appointment.links || []);

                    currentAppointment.updateAppointment.requestTransformation = ({ url, methodData, data }) => {
                        url += "/confirmationcode/" + apptConfirmationCode;
                        return { url, methodData, data };
                    };
                    return currentAppointment.updateAppointment(appointment)
                } else {
                    return department.createAppointment(appointment)
                }

            })
            .then(function (result) {
                var defer = $q.defer();
                ssWidgetService.addTag(result.confirmationCode, 'urn.dfx.confirmation-code')
                    .finally(function () {
                        defer.resolve(result);
                    });
                return defer.promise;
            })
            .then(function (result) {
                console.log(result);
                sendStatistics(appointment);
                stopTimeout();
                customerModelService.setCurrentAppointment(result);
                customerModelService.setCurrentAdviser(result.advisor);

                if (!customerModelService.isCustomerVerified()) {
                    sdAnalyticsService.sendScheduleServiceAccountCreated();
                }

                var mileage = _.get(vehicle, 'odometer', null);
                var services = customerModelService.getSelectedMaintenanceServices();
                sdAnalyticsService.sendServiceScheduleApptSet(vehicle, mileage, services);
                sdAnalyticsService.resetSession();

                //33926: FCA MVP - OS - Save Appointment Services with MVP Flag
                if (Date.parse($scope.serviceContractEndDate) >= Date.parse($scope.scheduledUnFormatedDateTime)) {
                    UpdateMVPServiceContract(result, customerModelService.getCurrentDepartment());
                }

                $state.go('confirmation');
            })
            .catch(function (err) {
                // Temporariy fix to ignore "504 Gateway Timeout" or "504 Gateway Time-out" error.
                if (_.includes(err.statusText.toUpperCase(), 'GATEWAY TIME') || err.status == '504') {
                    stopTimeout();
                    $state.go('confirmation');
                } else {
                    $scope.bookError = true;
                    var errorScreenOptions = {
                        tryAgainHandler: tryAgainHandler,
                        gotoMainHandler: gotoMainHandler
                    };

                    function tryAgainHandler() {
                        $scope.bookError = false;
                        errorScreenService.error(false, ERR.BOOK_ERROR);
                        createAppointment();
                    }

                    function gotoMainHandler() {
                        $state.go('bookappointment.schedule');
                    }

                    $scope.errorScreenOptions = _.merge({}, errorScreenOptions, defaultErrorScreenOptions);
                    stopTimeout();
                    errorScreenService.error(true, ERR.BOOK_ERROR);
                }
            });
    }

    function UpdateMVPServiceContract(appointment, department) {
        var selectedFRS = customerModelService.getFactoryRequiredServices().filter(x => x.selected);
        var isServiceContractValid = customerModelService.isServiceContractValid();
        var serviceContract = customerModelService.getServiceContract();

        if (selectedFRS != undefined && selectedFRS.length > 0 && serviceContract != undefined) {
            var serviceContractEntry = [];

            angular.forEach(selectedFRS, function (el) {
                if (el.mvpServiceContractTireRotation == apiConstants.SERVICECONTRACTS.TireRotaion && isServiceContractValid.IsContractTireRotaionValid) {
                    serviceContractEntry.push(GenerateServiceContractEntry(el.id, serviceContract));
                }
                else if (el.mvpServiceContractOilChange == apiConstants.SERVICECONTRACTS.OilFilterChange && isServiceContractValid.IsContractOilValid) {
                    serviceContractEntry.push(GenerateServiceContractEntry(el.id, serviceContract));
                }
            });

            if (serviceContractEntry.length > 0 && appointment != undefined && appointment.appointmentId > 0) {
                var appointmentOpcodeCollection = {
                    appointmentId: appointment.appointmentId,
                    selectedServices: serviceContractEntry
                };

                department.updateMVPServiceContract(appointmentOpcodeCollection)
            }
        }
    }

    function GenerateServiceContractEntry(id, serviceContract) {
        return {
            serviceId: id,
            serviceContractCode: serviceContract.ProgramNumber,
            serviceContractDescription: serviceContract.ProgramName,
            serviceContractExpiryDate: serviceContract.EndDate,
            serviceContractExpiryMileage: serviceContract.EndOdometer
        };
    }

    var timeoutIntervalPromise;
    var timeout = 60;

    function showTimeout(title) {
        $scope.timeoutTitle = title;
        $scope.showTimeoutMessage = true;
        $scope.timeLeft = timeout;
        updateTimeout();
        startTimeout();
    }

    function startTimeout() {
        //Don't create a new timer promise if already exist.
        if (!_.isUndefined(timeoutIntervalPromise)) return;
        timeoutIntervalPromise = $interval(function () {
            $scope.timeLeft--;
            if ($scope.timeLeft <= 0) stopTimeout();
            else updateTimeout();
        }, 1000);
    }

    function stopTimeout() {
        $scope.showTimeoutMessage = false;
        if (!_.isUndefined(timeoutIntervalPromise)) {
            $interval.cancel(timeoutIntervalPromise);
            timeoutIntervalPromise = undefined;
        }
    }

    function updateTimeout() {

        function f(n) {
            return ('' + n).length == 1 ? '0' + n : '' + n;
        }

        var timeLeft = $scope.timeLeft;
        $scope.timeLeftString = f(Math.floor(timeLeft / 60)) + ':' + f(timeLeft % 60);
        updateSvgProcess(timeLeft / timeout * 100);
    }

    var svgAnimationId;

    function updateSvgProcess(val) {
        try {
            var $circle = angular.element($element[0].querySelector('svg#icon--timer .counter__progress'));

            if (_.isNaN(val)) val = 100;

            var r = parseFloat($circle.attr('r'));
            var c = Math.PI * (r * 2);

            val = Math.max(0, Math.min(100, val));

            var startStrokeDashoffset = parseFloat($circle.attr('stroke-dashoffset'));
            var endStrokeDashoffset = (val / 100) * c;
            stopAnimation(svgAnimationId);
            svgAnimationId = animate({
                delay: 10,
                duration: 1000,
                delta: function (p) {
                    return p;
                },
                step: function (delta) {
                    $circle.attr('stroke-dashoffset', startStrokeDashoffset + (endStrokeDashoffset - startStrokeDashoffset) * delta);
                }
            });
        } catch (e) {

        }
    }

    function animate(opts) {

        var start = new Date();

        var id = setInterval(function () {
            var timePassed = new Date() - start;
            var progress = timePassed / opts.duration;

            if (progress > 1) progress = 1;

            var delta = opts.delta(progress);
            opts.step(delta);

            if (progress == 1) {
                clearInterval(id);
            }
        }, opts.delay || 10);

        return id;
    }

    function stopAnimation(id) {
        id && clearInterval(id);
    }

    $scope.cancelAppointment = function () {
        showTimeout('cancel');
        $scope.cancelingAppointment = true;
        $scope.currentAppointment.removeAppointment().then(function () {
            $state.go('cancel');
        })
            .catch(function (err) {
                //if appointment has already been cancelled.
                if (err.statusText == "Appointment has no department") {
                    $state.go('cancel');
                    return;
                }

                //other error cases
                $scope.bookError = true;
                var errorScreenOptions = {
                    tryAgainHandler: tryAgainHandler,
                    gotoMainHandler: gotoMainHandler
                };

                function tryAgainHandler() {
                    $scope.bookError = false;
                    errorScreenService.error(false, ERR.BOOK_ERROR);
                    $scope.cancelAppointment();
                }

                function gotoMainHandler() {
                    $state.go('bookappointment.schedule');
                }

                $scope.errorScreenOptions = _.merge({}, errorScreenOptions, defaultErrorScreenOptions);
                errorScreenService.error(true, ERR.BOOK_ERROR);
            })
            .finally(function () {
                stopTimeout();
                $scope.cancelingAppointment = false;
            });
    };

    // removeService
    //
    // @param {Object} service to remove
    //
    // @description
    // Remove given service from set of selected by customer services
    // and re-calculate summary price
    $scope.removeService = function (service) {
        service.selected = false;
        //service.comment = null;
        $scope.services = customerModelService.getSelectedMaintenanceServices();
        getSummaryPrice();
    };

    $scope.onToggleRecallOrAlerts = function () {
        $scope.services = customerModelService.getSelectedMaintenanceServices();
        getSummaryPrice();
    };

    $scope.toggleCancelPopup = function (state) {
        $scope.cancelPopupVisible = state;
    };

    $scope.toggleInfoPopUp = function (service) {
        $scope.amenityService = service || {};
        $scope.infoPopUpVisible = !$scope.infoPopUpVisible;
    };

    var bookErrorListenerId = errorScreenService.subscribe(function (recipient, error) {
        if (recipient === bookErrorListenerId) {
            //hide/show page content according to value of the error parameter
            $scope.bookError = error;
            //start/stop count down
            switch (error) {
                case true:
                    stopTimeout();
                    break;
                case false:
                    showTimeout();
                    break;
            }
            $scope.$apply();
        }
    });

    $scope.getPrevState = function () {
        if (previousState.name === 'checkhealth') {
            return previousState.name;
        }
    };

    $scope.isBookedApp = function () {
        return !$scope.newCustomer && $scope.currentAppointment && $scope.currentAppointment.status === 'booked';
    };

    $scope.isSummarySurveyState = function () {
        return $state.is('summary.survey');
    };

    $scope.$on('$destroy', function () {
        frsListener();
        httpErrorsListeners.forEach(function (id) {
            errorRouterService.unsubscribe(id);
        });
        errorScreenService.unsubscribe(bookErrorListenerId);
        //prevent updating timer after the DOM element was removed.
        stopTimeout();
    });

    $scope.hideOnUiServiceFilter = function (s) {
        return !s.hideOnUi || s.selected;
    }
    $scope.serviceContractsValid = function () {
        return customerModelService.isServiceContractValid();
    }
    $scope.numberComparison = {
        serviceContractOilChangeValue: apiConstants.SERVICECONTRACTS.OilFilterChange,
        serviceContractTireRotationValue: apiConstants.SERVICECONTRACTS.TireRotaion,
        zeroServicePrice: apiConstants.SERVICEPRICE.Zero
    };

    $scope.HideStringType = Object.freeze({
        FIRST_NAME: "FIRST_NAME",
        LAST_NAME: "LAST_NAME",
        PHONE: "PHONE",
        EMAIL: "EMAIL",
    });

    $scope.hideString = function (value, type) {
        if (_.isNil(value)) return "";
        if (type === $scope.HideStringType.FIRST_NAME)
            return value[0] + "*".repeat(value.length - 1);
        else if (type === $scope.HideStringType.LAST_NAME)
            return "*".repeat(value.length - 1) + value[value.length - 1];
        else if (type === $scope.HideStringType.PHONE) {
            value = $filter('phone')(value);
            return value.split('').map((value, i, list) => {
                if (/^\d+$/.test(value) && i < (list.length - 3)) return "*";
                return value;
            }).join('');
        }
        else if (type === $scope.HideStringType.EMAIL) {
            function mask(str) {
                const replaceMask = /a-z|A-Z|0-9|.|_|-|/g;
                const strLen = str.length;
                if (strLen > 4) {
                    return str.substr(0, 1) + str.substr(1, strLen - 1).replace(replaceMask, '*') + str.substr(-1, 1);
                }
                return str.replace(replaceMask, '*');
            }
            return value.replace(/([a-zA-Z0-9._-]+)@([a-zA-Z0-9._-]+)(\.[a-zA-Z0-9_.-]+)/gm, function (m, p1, p2, p3) {
                return mask(p1) + '@' + mask(p2) + p3;
            });
        }
    }

    function checkProtectionPlanUpdates() {
        if (customerModelService.getProtectionPlansUpdates()) {
                $scope.protectionPlans  = customerModelService.getProtectionPlansUpdates();
                customerModelService.setProtectionPlansUpdates($scope.protectionPlans);      
         }
         else{
             $scope.protectionPlanPending = true;
             customerModelService.resolveProtectionPlansUpdates().then(function (data) {
                 if (_.size(data) > 0) {
                    $scope.protectionPlans = data.ProtectionPlans;
                    customerModelService.setProtectionPlansUpdates($scope.protectionPlans);  
                     $scope.showUpdatesMsg = true;
                 }
                 else     $scope.protectionPlans = [];
             })
                 .catch(function (err) {
                     $scope.protectionPlans = [];
                     $scope.protectionPlanPending = false;
                 })
                 .finally(function () {
                     $scope.protectionPlanPending = false;
                 });
               
         }
     }
};
AppointmentSummaryCtrl.$inject = ['$rootScope', '$scope', '$element', '$interval', '$anchorScroll',
    'previousState', 'customerModelService', '$log', 'SettingsConstants', '$state', 'apiService', '$q',
    'dealerModelService', 'VALIDATION', 'LoaderService', 'maintenanceModelService',
    'errorScreenService', 'errors', 'errorRouterService', 'ssWidgetService', '$timeout',
    'sdAnalyticsService', 'VehicleService', 'ApiConstants', '$filter'];

module.exports = AppointmentSummaryCtrl;
